export function  cycleRes() {
    if (typeof chrome !== 'undefined' && chrome.runtime) {
        window.chrome.runtime.sendMessage(import.meta.env.VITE_CHROME_EXTENSION_ID, {
            action: 'cycleResolution'
        }, (response) => {
            console.log('Extension responded:', response);
        });
    }
}

export function setRes() {
    if (typeof chrome !== 'undefined' && chrome.runtime) {
        window.chrome.runtime.sendMessage(import.meta.env.VITE_CHROME_EXTENSION_ID, {
            action: 'setResolution'
        }, (response) => {
            console.log('Extension responded:', response);
        });
    }
}